import {Component, OnInit} from '@angular/core';
import {ContractService} from './contract.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractDetail} from '../models/ContractDetail';
import {Charge} from '../models/Charge';
import {MatTableDataSource} from '@angular/material/table';
import {BoxAccessUsers} from '../models/BoxAccessUsers';
import {Parameters} from '../models/Parameters';
import {Financial} from '../models/Financial';
import {FinancialService} from '../financial/financial.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {

  public contract: ContractDetail = {} as ContractDetail;
  public parameters: Parameters = {} as Parameters;
  public id: string;
  public dataSourceFinanceiro: MatTableDataSource<Charge> = new MatTableDataSource<Charge>();

  public dataSourceFinancial: MatTableDataSource<Financial> = new MatTableDataSource<Financial>();
  public displayedColumnsFinancials: string[];

  public dataSourceBoxAccessUsers: MatTableDataSource<BoxAccessUsers> = new MatTableDataSource<BoxAccessUsers>();
  public displayedColumnsBoxAccessUsers: Array<string>;

  public codeUser: string = localStorage.getItem('CODIGO_CADASTRO_GERAL') ?? "";

  public formUsuarioPrincipal: FormGroup = new FormGroup({
    CA_NOME_DISPLAY: new FormControl('', [Validators.required]),
    CA_CODIGO_ACESSO: new FormControl('', [Validators.required]),
  });
  constructor(
    private service: ContractService,
    private route: ActivatedRoute,
    private router: Router,
    private serviceFinancial: FinancialService
  ) {
    this.displayedColumnsFinancials = [
      // 'CODIGO_COMPLETO_LANCAMENTO',
      'DESCRICAO_LANCAMENTO',
      'DATA_EMISSAO',
      'DATA_VENCIMENTO',
      'VALOR_PREVISAO',
      'DATA_REAL',
      // 'VALOR_REAL_FORMATADO',
      // 'CODIGO_BOLETO'
    ];

    this.displayedColumnsBoxAccessUsers = [
      'CPF',
      'NOME',
      'MENSAGEM_ACESSO_LIBERADO',
      'NOME_DISPLAY',
      'CODIGO_ACESSO'
    ];

    this.id = this.route.snapshot.params["id"];
  }

  ngOnInit(): void {
      this.service.showSpinner();
      this.service.getContract(this.id).subscribe(data => {
        this.contract = data;
        this.dataSourceFinanceiro = new MatTableDataSource<Charge>(this.contract.LANCAMENTOS);
        this.dataSourceBoxAccessUsers = new MatTableDataSource<BoxAccessUsers>(this.contract.USUARIOS_ACESSO);
        if (this.contract.CONTRATO.INADIMPLENCIA){
          this.service.toasterWarning('Parece que este contrato está inadimplente. Por favor, faça a regularização para garantir acesso ao box.', 'Importante');
        }
        this.formUsuarioPrincipal.patchValue(this.contract.CADASTRO_GERAL);
        this.service.hideSpinner();
      }, error => {
        console.error(error);
        this.service.toasterError(error.error);
      });
      this.serviceFinancial.getFinancialList(this.codeUser, this.id).subscribe(data => {
        this.dataSourceFinancial = new MatTableDataSource<Financial>(data as any);
        // this.service.hideSpinner();
      }, error => {
        console.error(error);
        this.service.toasterError(error.error);
      });
  }

  returnToDashboard(): void{
    this.router.navigate(['principal/contratos']);
  }

  openInvoice(id: string): void {
    this.router.navigate(['principal/faturas/' + id]);
  }

  public redirect(uri: string): void {
    this.router.navigate([uri]);
  }

  public includeNewBoxUser = (codigoContrato: string): void => {
    this.router.navigate(['principal/acesso-box-usuario/0/' + codigoContrato]);
  }

  public saveMainUserData(): void{
    this.service.showSpinner();
    this.service.saveMainAccessControl(this.id, this.formUsuarioPrincipal.getRawValue()).subscribe(data => {
      this.service.hideSpinner();
      this.service.toasterSuccess('Dados atualizados', 'Sucesso!');
    }, err => {
      this.service.hideSpinner();
      this.service.toasterError('Houve um erro ao salvar seus dados. Tente mais tarde');
    });
  }

  public loadDataBoxAccessUser = (id: string, codigoContrato: number):void => {
    if (id.toString().trim() === '') {
      this.service.hideSpinner();
      return;
    }
    if (codigoContrato.toString().trim() === '') {
      this.service.hideSpinner();
      return;
    }
    // localStorage.setItem('codigo-contrato', codigoContrato.toString());
    // localStorage.setItem('id-box-access-user', id);
    this.router.navigate(['principal/acesso-box-usuario/' + id + '/' + codigoContrato]);
  }
}
